import React from "react";
import styles from "./novicaPreview.module.css";
import Link from "gatsby-link";
import AsyncImage from "../AsyncImage";

export default ({ novica: { id, naslov, slika, opis, datum } }) => (
  <div className={styles.outerContainer}>
    <Link to={`/novice/${id}`} className={styles.naslovAnchor}>
      <AsyncImage
        className={styles.headerImage}
        imageUrl={slika.file.url}
        alt={slika.description}
        placeholderColor="#ecf0f1"
      />
      <div className={styles.heading}>{naslov}</div>
    </Link>
    <div className={styles.datum}>{datum}</div>
    <div className={styles.opis}>{opis}</div>
    <Link className={styles.preberiVec} to={`/novice/${id}`}>
      Nadaljuj z branjem
    </Link>
    <div className={styles.divider} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/NovicaPreview/index.js